import React from 'react';
import { Package } from 'lucide-react';

export default function ProductCard({ product, onAddToCart, onViewDetails }) {
  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow overflow-hidden">
      <div 
        className="h-48 bg-gray-100 flex items-center justify-center cursor-pointer"
        onClick={() => onViewDetails(product.id)}
      >
        {product.image ? (
          <img src={product.image} alt={product.name} className="w-full h-full object-cover" />
        ) : (
          <Package size={64} className="text-gray-300" />
        )}
      </div>
      <div className="p-4">
        <div className="text-sm text-gray-500 mb-1">{product.category}</div>
        <h3 
          className="font-semibold text-lg mb-2 cursor-pointer hover:text-red-600"
          onClick={() => onViewDetails(product.id)}
        >
          {product.name}
        </h3>
        <p className="text-gray-600 text-sm mb-3 line-clamp-2">{product.description}</p>
        <div className="flex items-center justify-between mb-2">
          <span className="text-xl font-bold text-red-600">${product.price}</span>
          <span className="text-sm text-gray-500">{product.stock} in stock</span>
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => onViewDetails(product.id)}
            className="flex-1 bg-gray-200 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-300 transition-colors font-medium"
          >
            View Details
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onAddToCart(product);
            }}
            disabled={product.stock === 0}
            className="flex-1 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed font-medium"
          >
            {product.stock === 0 ? 'Out of Stock' : 'Add to Cart'}
          </button>
        </div>
      </div>
    </div>
  );
}